import { defineComponent as _defineComponent } from 'vue'
import { UserflowTriggers } from '@/services/userflow/userflow';
  import { user } from '@/ui/auth/auth';
  import YoutubeIframe from '@/ui/components/common/YoutubeIframe.vue';
  import { useModal } from '@/ui/concerns/modals/useModal';
  import { useWindowMessage } from '@/ui/concerns/useWindowMessage';
  // @ts-ignore
  import { BModal } from 'buefy/dist/esm/modal';
  import { computed } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'YoutubeModal',
  setup(__props) {

  const videoId = computed(() => {
    switch (user.value?.locale) {
      case 'de':
        return 'IoV_5xElXMU';
      case 'es':
        return 'v-kSGzBOa3w';
      default:
        return 'bZu4-WjkcdY';
    }
  });

  const [isModalOpen, openModal, closeModal] = useModal();

  useWindowMessage(UserflowTriggers.SHOW_YOUTUBE_VIDEO, () => {
    openModal();
  });

return { __sfc: true,videoId, isModalOpen, openModal, closeModal, YoutubeIframe, BModal }
}

})